<div class="rebalanceScheduleEnable left">
  <div class="left" style="line-height: 27px; font-weight: 700;padding-right: 8px;">
    <p-radioButton name="RestoreGroup" value="None" [(ngModel)]="schedulerType"
      (ngModelChange)="onChangeOneTime()" [disabled]="nowSchedulerDisable || schedulerNotApplicable"
    inputId="rsitem1"></p-radioButton>
    <label for="rsitem1">Now</label>
  </div>
  <div class="left scheduleLater" style="line-height: 27px; font-weight: 700;">
    <p-radioButton name="RestoreGroup" value="Scheduled" [(ngModel)]="schedulerType"
      (ngModelChange)="onChangeRecurring()" [disabled]="schedulerDisable || schedulerNotApplicable"
    inputId="rsitem2"></p-radioButton>
    <label for="rsitem2">Later</label>
  </div>
</div>
<div class="clear"></div>
@if (recurringShow) {
  <div>
    <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
    <div class="pattern left">
      <div class="clear">
        <span class="rebalanceScheduleLabel left"><strong>Schedule</strong></span>
      </div>
      <div class="rebalanceSchedulePatternRow clear" style="display: flex;flex-direction: row;align-items: center;line-height: 20px;padding-top: 15px;">
        <div class="rebalanceSchedulePatternLabel "><strong>Repeats</strong></div>
        <div >
          <p-radioButton  name="RestoreGroupRecurring" value="Daily" [(ngModel)]="data.scheduler.reccuringFreqType"
          (ngModelChange)="onDailyChange()" inputId="rsitem3"></p-radioButton>
          <label class="rebalanceSchedulePatternRadio" for="rsitem3">Daily</label>
        </div>
        <div>
          <p-radioButton  name="RestoreGroupRecurring" value="Weekly" [(ngModel)]="data.scheduler.reccuringFreqType"
          (ngModelChange)="onWeeklyChange()" inputId="rsitem4"></p-radioButton>
          <label class="rebalanceSchedulePatternRadio" for="rsitem4">Weekly</label>
        </div>
        <div >
          <p-radioButton  name="RestoreGroupRecurring" value="Monthly" [(ngModel)]="data.scheduler.reccuringFreqType"
          (ngModelChange)="onMonthlyChange()" inputId="rsitem5"></p-radioButton>
          <label class="rebalanceSchedulePatternRadio" for="rsitem5">Monthly</label>
        </div>
      </div>
      <div class="rebalanceSchedulePatternRow clear">
        <span class="scheduleFrequencyLeftLabel left"><strong>Every</strong></span>
        @if (everyDay) {
          <irb-number-text-box name="rblFrequency" class="rebalanceScheduleFrequencyInputBox"
            [(value)]="data.scheduler.everyNDays" min="1" max="365"
            invalidRangeMessage="Please enter a number of days between 1 and 365."
            invalidMessage="Please enter a number of days between 1 and 365."
            placeholder="" width="60px">
          </irb-number-text-box>
          <span class="scheduleFrequencyRightLabel">Day(s)</span>
        }
        @if (weekDay) {
          <irb-number-text-box name="rblFrequency" class="rebalanceScheduleFrequencyInputBox"
            [(value)]="data.scheduler.everyNWeeks" min="1" max="52"
            invalidRangeMessage="Please enter a number of weeks between 1 and 52."
            invalidMessage="Please enter a number of weeks between 1 and 52."
            placeholder="" width="60px">
          </irb-number-text-box>
          <span class="scheduleFrequencyRightLabel">Week(s)</span>
        }
        @if (monthlyScheduler) {
          <irb-number-text-box name="rblFrequency" class="rebalanceScheduleFrequencyInputBox"
            [(value)]="data.scheduler.everyNMonths" min="1" max="12"
            invalidRangeMessage="Please enter a number of months between 1 and 12."
            invalidMessage="Please enter a number of months between 1 and 12."
            placeholder="" width="60px">
          </irb-number-text-box>
          <span class="scheduleFrequencyRightLabel">Month(s)</span>
        }
      </div>
      @if (weekDay) {
        <div style="padding-top:15px;">
          <span class=" left" style="width:65px;"><strong>On</strong></span>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'Tu'" [(ngModel)]="data.scheduler.tuesday" binary="true"
            inputId="rsitem6"></p-checkbox>
            <label for="rsitem6">Tue</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'W'" [(ngModel)]="data.scheduler.wednesday" binary="true"
            inputId="rsitem7"></p-checkbox>
            <label for="rsitem7">Wed</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'Th'" [(ngModel)]="data.scheduler.thursday" binary="true"
            inputId="rsitem8"></p-checkbox>
            <label for="rsitem8">Thu</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'F'" [(ngModel)]="data.scheduler.friday" binary="true"
            inputId="rsitem9"></p-checkbox>
            <label for="rsitem9">Fri</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'S'" [(ngModel)]="data.scheduler.saturday" binary="true"
            inputId="rsitem10"></p-checkbox>
            <label for="rsitem10">Sat</label>
          </div>
        </div>
      }
      @if (monthlyScheduler) {
        <div class="left monthlySchedulerDiv clear">
          <span class="scheduleFrequencyLeftLabel left"><strong>On</strong></span>
          <div class="left monthlyScheduler">
            <div class="monthlySchedulerRow clear">
              <div class="monthlySchedulerSwitch left">
                <p-radioButton class="monthlySchedulerRadio" name="monthlySchedulerGroup" value="0" [(ngModel)]="monthlySchedulerOption"
                (ngModelChange)="onMonthlySchedulerSwitch()"></p-radioButton>
              </div>
              <div class="left" tooltip [tooltipTitle]="endOfMonthWarning" tooltipPosition="right" tooltipClass="error">
                <irb-number-text-box style="display: block;" min="1" max="31"
                  [(value)]="data.scheduler.dateNumber" width="50px"
                  invalidRangeMessage="Please enter a number between 1 and 31" (keyup)="validateDateNumberInput()"
                  [disabled]="monthlySchedulerOption==='1'">
                </irb-number-text-box>
              </div>
              <div class="left"><span style="margin-left:15px;"> day of the month</span></div>
            </div>
            <div class="monthlySchedulerRow clear">
              <div class="monthlySchedulerSwitch left">
                <p-radioButton class="monthlySchedulerRadio" name="monthlySchedulerGroup" value="1" [(ngModel)]="monthlySchedulerOption"
                (ngModelChange)="onMonthlySchedulerSwitch()"></p-radioButton>
              </div>
              <div class="left">
                <irb-dropdown-filter #IrbendDeveryMonthListDropdown class="monthlySchedulerDropDown"
                  [value]="evryMonthListOptions"
                  [size]="15"
                  (search)="setChainTypeEveryMonthListOptions()"
                  (selection)="monthSelection($event)"
                  [disabled]="monthlySchedulerOption==='0'"
                  [placeholder]="'the 1st'"
                ></irb-dropdown-filter>
              </div>
              <div class="left">
                <irb-dropdown-filter #IrbendDeveryMonthWeekDayListDropdown class="monthlySchedulerWeekDayDropDown"
                  [(value)]="evryMonthWeekDayListOptions"
                  [size]="10"
                  (search)="setChainTypeEveryMonthWeekDayListOptions()"
                  (selection)="onEveryDayList($event)"
                  [disabled]="monthlySchedulerOption==='0'"
                  [placeholder]="'Tue'"
                ></irb-dropdown-filter>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="duration left">
      <div class="clear">
        <span class="durationLabel"><strong>Duration</strong></span>
      </div>
      <div class="durationStart">
        <span class="durationStartLabel"><strong>Starts</strong></span>
        <div class="mat-datepicker-container">
          <input class="rebalanceScheduleStartDate"
            [class]="toolTipStartDate !== ''? 'input-not-valid' : ''"
            tooltip
            [tooltipTitle]="toolTipStartDate"
            [tooltipPosition]="'right'"
            tooltipClass="error"
            [tooltipHorizontalOffset]="8"
            matInput [matDatepicker]="picker1" [min]="currentSchedulerDate" class="date-control end-date"
            [matDatepickerFilter]="myFilter" [formControl]="schedulerStartDate" (dateChange)="startDateChange()">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1 color="primary"></mat-datepicker>
          </div>
        </div>
        <div class="durationEnd left">
          <span class="durationEndLabel left"><strong>Ends</strong></span>
          <div class="endOptions left">
            <div class="endOptionsRow clear">
              <div class="endOptionSwitch left">
                <p-radioButton class="endOptionRadio" name="endOptionsGroup" value="No End Date" [(ngModel)]="data.scheduler.endDateType"
                (ngModelChange)="endOptionChange()" inputId="rsitem11"></p-radioButton>
              </div>
              <div class="left endOptionLabel"><span for="rsitem11"> Never</span></div>
            </div>
            <div class="endOptionsRow clear">
              <div class="endOptionSwitch left">
                <p-radioButton class="endOptionRadio" name="endOptionsGroup" value="End after # occurrences" [(ngModel)]="data.scheduler.endDateType"
                (ngModelChange)="endOptionChange()" inputId="rsitem12"></p-radioButton>
              </div>
              <div class="left endOptionLabel"><span for="rsitem12"> After</span></div>
              <div class="left date-end-after-input">
                <irb-number-text-box [(value)]="data.scheduler.endAfterNTimes"
                  [disabled]="!(data.scheduler.endDateType ==='End after # occurrences')"
                  (valueChange)="endAfterNTimesChange($event)"
                  [min]="1" [max]="1000" width="50px"
                height="28px"></irb-number-text-box>
              </div>
              <div class="left"><span style="margin-left:15px;"> occurrences</span></div>
            </div>
            <div class="endOptionsRow clear">
              <div class="endOptionSwitch left">
                <p-radioButton class="endOptionRadio" name="endOptionsGroup" value="End by (date)" [(ngModel)]="data.scheduler.endDateType"
                (ngModelChange)="endOptionChange()" inputId="rsitem13"></p-radioButton>
              </div>
              <div class="left endOptionLabel"><span for="rsitem13"> On</span></div>
              <div class="left dateStartDateDiv">
                <div class="mat-datepicker-container">
                  <input class="rebalanceScheduleEndInputBox"
                    [class]="toolTipEndDate !== ''? 'input-not-valid' : ''"
                    tooltip
                    [tooltipTitle]="toolTipEndDate"
                    [tooltipPosition]="'right'"
                    tooltipClass="error"
                    [tooltipHorizontalOffset]="8"
                    [disabled]="!(data.scheduler.endDateType ==='End by (date)')"
                    [readonly]="!(data.scheduler.endDateType ==='End by (date)')"
                    matInput [matDatepicker]="picker2" [min]="endDateValidation" class="date-control end-date"
                    [matDatepickerFilter]="myFilter" [formControl]="schedulerEndByDate" (dateChange)="endDateChange()">
                    <mat-datepicker-toggle [disabled]="!(data.scheduler.endDateType ==='End by (date)')" matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2 color="primary">
                    </mat-datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
